module.exports = __webpack_public_path__ + "img/Hawaii Bingo.1d590812.jpeg";